import { render, staticRenderFns } from "./dailyStatementAffTab.vue?vue&type=template&id=4973d0f0&lang=pug"
import script from "./dailyStatementAffTab.vue?vue&type=script&lang=js"
export * from "./dailyStatementAffTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports